import { func, object, arrayOf, string } from 'prop-types';
import { path } from 'ramda';
import React from 'react';

import ContentColumns from '../../components/ContentColumns';
import { getAllCommitsData } from 'lib/documentHandling';

const View9 = ({ documents }, { fmString, editingDocumentId, viewingIdContext }) => {
  const thisDocument = documents.find(d => d.documentId === (editingDocumentId || viewingIdContext));
  const comments = path(['rehab5', 'neurologistsComments'], getAllCommitsData(thisDocument, true));

  return (
    <ContentColumns
      firstColumn={
        <div>
          <h2>{fmString('onlineRehabilitation.rehab5.9.header')}</h2>
          <br />
          <div>{fmString('onlineRehabilitation.rehab5.9.text')}</div>
          <br />
          <div>{fmString('onlineRehabilitation.rehab5.9.comments', { comments: comments ? 1 : 0 })}</div>
        </div>
      }
    />
  );
};

View9.contextTypes = {
  fmString: func,
  editingDocumentId: string,
  viewingIdContext: string,
};
View9.propTypes = {
  documents: arrayOf(object),
};

export default View9;
